
export default function() {
    const self = this;

    self.distances = [];

    self.set = (distances) => {
        self.distances = distances;
    };

    self.get = (cinemaSlug = '') => {

        if(cinemaSlug) {
            if(typeof this.distances[cinemaSlug] !== 'undefined') {
                return this.distances[cinemaSlug];
            }
        }

        return this.distances;

    };


}


// WEBPACK FOOTER //
// ./resources/js/MrMovie/Filters/CinemaDistances.js